import React from 'react';
import PropTypes from 'prop-types';
import { MediaCacheShape } from 'utils/shapes';
import ArenaFavouriteIcon from 'components/arena/ArenaFavouriteIcon';
import ArenaIcon from 'components/arena/ArenaIcon';

const ArenaIconBar = ({ item, commentsLink }) => (
    <div className="arena__item__bottom__right">
        <a href={commentsLink}>
            <ArenaIcon iconName="comment" number={item.number_of_public_comments} />
        </a>
        <ArenaFavouriteIcon itemId={item.id} number={item.number_of_favourites} />
        <ArenaIcon iconName="eye" number={item.number_of_visits} />
    </div>
);

ArenaIconBar.propTypes = {
    item: MediaCacheShape.isRequired,
    commentsLink: PropTypes.string.isRequired,
};

export default ArenaIconBar;



// WEBPACK FOOTER //
// ./src/components/arena/ArenaIconBar.js